import { createAction } from 'redux-actions';

export const setLoadingOverlay = createAction('SET_LOADING_OVERLAY');
export const clearLoadingOverlay = createAction('CLEAR_LOADING_OVERLAY');
